import axios from "axios";

export const API_URL = process.env.REACT_APP_API_URL;
const PCLOUD_URL = "https://eapi.pcloud.com";

export const ServiceAPI = {
    login: () => {
        return axios.get(`${API_URL}/Service/getToken`);
    },

    getPCloudStatus: () => {
        return axios.get(`${API_URL}/Service/pcloud/status`);
    },

    createFolder: (_accessToken, folderId, folderName) => {
        const normalizedFolderId = String(folderId ?? "").trim();
        if (!/^[1-9]\d*$/.test(normalizedFolderId)) {
            return Promise.reject(new Error("Missing pCloud parent folder id."));
        }

        const url = `${PCLOUD_URL}/createfolderifnotexists?access_token=${encodeURIComponent(_accessToken)}&folderid=${encodeURIComponent(normalizedFolderId)}&name=${encodeURIComponent(folderName)}`;
        return axios.get(url, { headers: { "user_authorization": undefined } });
    },

    ensureServiceFolder: (serviceNumber) => {
        return axios.get(`${API_URL}/Service/ensureFolder/${serviceNumber}`);
    },

    createService: (data) => {
        return axios.post(`${API_URL}/Service/createService`, data);
    },

    upload_file: async (accessToken, folderId, file, setUploadProgress, index, signal) => {
        const formData = new FormData();
        formData.append("file", file);

        const url = `${PCLOUD_URL}/uploadfile?access_token=${encodeURIComponent(accessToken)}&nopartial=1&folderid=${folderId}&filename=${encodeURIComponent(file.name)}`;

        return axios.post(url, formData, {
            signal,
            headers: {
                "Content-Type": "multipart/form-data",
                "user_authorization": undefined
            },
            onUploadProgress: (progressEvent) => {
                const total = progressEvent.total || 1;
                const percentCompleted = Math.round((progressEvent.loaded * 100) / total);
                setUploadProgress((prev) => ({ ...prev, [index.toString()]: percentCompleted }));
            }
        });
    },

    createVideoUpload: (data) => {
        return axios.put(`${API_URL}/Service/addUpload`, data);
    }
};
